import axios from "axios";
import { Config } from "../../Common/Config";
import { getDeviceInfo } from "../../../utils/deviceInfo"

const ENDPOINT = `${Config.urlOpen}trace-log/init`;

/**
 * Send a session event trace to the trace-log API.
 * @param {Object} params - Event params
 * @param {string} params.module - e.g. 'booking'
 * @param {string} params.log_name - e.g. 'BookingJourney'
 * @param {string} params.event - e.g. 'booking_flow_started'
 * @param {Object} params.payload - event payload
 * @param {string} [token] - optional Authorization token (Bearer ...) ; if omitted no Authorization header is sent
 * @returns {Promise<Object>} response data
 */
const generateSessionEventPush = async (
  { module, log_name, event, payload },
  token
) => {
  try {
    let deviceData = getDeviceInfo()
    let newPayload = { ...payload, deviceInfo: deviceData }
    const headers = { "Content-Type": "application/json" };
    if (token) headers["Authorization"] = token;

    const body = { module, log_name, event, payload: newPayload };

    const res = await axios.post(ENDPOINT, body, { headers });
    // console.log("res:", res);

    localStorage.setItem("trace_log_id", res?.data?.trace_log?.session_id);
    return res.data;
  } catch (err) {
    // bubble up a simplified error
    const message = err?.response?.data || err.message || err;
    throw message;
  }
};

export default generateSessionEventPush;

/**
 * Push a detailed log event to an existing trace session.
 * Reads `trace_log_id` from localStorage if `traceLogId` is not provided.
 * @param {Object} params - Event details
 * @param {string} params.event - event name (required)
 * @param {Object} params.payload - request data
 * @param {string} params.step_status - 'success'|'failed' (required)
 * @param {Object} [params.response] - response data
 * @param {Object} [params.meta] - additional metadata
 * @param {string} [token] - optional Authorization token
 * @param {string} [traceLogId] - optional trace_log_id override
 * @returns {Promise<Object>} response data
 */
export const pushTraceLogEvent = async (
  { event, payload, step_status, response, meta },
  token,
  traceLogId
) => {
  try {
    const id = traceLogId || localStorage.getItem("trace_log_id");
    if (!id)
      throw new Error(
        "trace_log_id not found in localStorage and not provided"
      );

    const url = `${Config.urlOpen}trace-log/log/${id}`;
    const headers = { "Content-Type": "application/json" };
    if (token) headers["Authorization"] = token;

    const body = { event, payload, step_status, response, meta };

    const res = await axios.post(url, body, { headers });
    return res.data;
  } catch (err) {
    console.error("pushTraceLogEvent validation/request error details:", err?.response?.data || err);
    const message = err?.response?.data || err.message || err;
    throw message;
  }
};
